import defaultState from "./state";

const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_BLOQUEOS_SCHEDULER": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "LOADING_BLOQUEO_MODAL_WIZARD": {
      return Object.assign({}, state, {
        isModalWizardLoading: action.isModalWizardLoading,
      });
    }
    case "OPEN_CLOSE_MODAL_CONFLICT_WEEK": {
      return Object.assign({}, state, {
        isOpenModalConflictWeek: action.isOpen,
        isOpenModalEditWeek: false,
      });
    }
    case "SET_FERIADOS_ADMIN_BLOQUEOS": {
      return Object.assign({}, state, {
        feriadosAdministrativos: action.feriados,
      });
    }
    case "SET_CENTER_CONFIG_BLOCKING": {
      return Object.assign({}, state, {
        centerConfig: action.config,
      });
    }
    case "OPEN_CLOSE_MODAL_DELETE_BLOCKING": {
      return Object.assign({}, state, {
        isOpenModalDeleteBlocking: action.isOpen,
        dataBlockingToDelete: action.data,
      });
    }
    case "SET_CENTER_ID_BLOCKING": {
      return Object.assign({}, state, {
        centerId: action.centerId,
      });
    }
    case "SET_APPOINTMENT_BLOCKINGS_LIST": {
      return Object.assign({}, state, {
        listaAppointments: action.list,
      });
    }
    case "SET_LIST_WORKING_DAYS": {
      return Object.assign({}, state, {
        listDaysWorking: action.listDaysWorking,
      });
    }
    case "SET_CENTER_LIST_BLOQUEOS": {
      return Object.assign({}, state, {
        centrosList: action.centrosList,
      });
    }
    case "SET_CONFIGURATION": {
      return Object.assign({}, state, {
        configList: action.list,
      });
    }
    case "SET_LIST_EXAM_POOL": {
      return Object.assign({}, state, {
        listExamPools: action.listExamPools,
      });
    }
    case "SET_LIST_EXAMS": {
      return Object.assign({}, state, {
        listExams: action.listExams,
      });
    }
    case "SET_LIST_EXAMS_CIEL": {
      return Object.assign({}, state, {
        listCiel: action.listCiel,
      });
    }
    case "SET_HIDE_SHOW_WIZARD_BLOCK": {
      return Object.assign({}, state, {
        isPopupWizardOpen: action.isPopupWizardOpen,
      });
    }
    case "SET_STEPS_WIZARD": {
      return Object.assign({}, state, {
        steps: action.steps,
      });
    }
    case "SET_BLOCKING": {
      return Object.assign({}, state, {
        blocking: action.blocking,
      });
    }
    case "SET_APPOINTMENT": {
      return Object.assign({}, state, {
        appointment: action.data,
      });
    }
    case "OPEN_CLOSE_MODAL_EDIT_WEEK": {
      return Object.assign({}, state, {
        isOpenModalEditWeek: action.isOpen,
        appointmentEditWeek: action.data,
      });
    }
    case "SET_APPOINTMENT_EDIT_WEEK": {
      return Object.assign({}, state, {
        appointmentEditWeek: action.data,
      });
    }
    case "SET_WEEK_APPOINTMENTS": {
      return Object.assign({}, state, {
        weekAppointments: action.list,
      });
    }
    case "SET_CONFIG_SCHEDULER_WIZARD": {
      return Object.assign({}, state, {
        configSchedulerWizard: action.configSchedulerWizard,
      });
    }
    case "SET_OPENING_DATA_BLOCKING":{
      let newBlocking = {...state.blocking};
      newBlocking.blockingData = action.data
      return Object.assign({}, state,{
        blocking: newBlocking
      })
    }
    case "SET_BLOCK_REASON_DATA":{
      return Object.assign({}, state, {
        blockReasonList: action.data
      })
    }
    case "RESET_BLOCKING_STATE": {
      return Object.assign({}, state, {
        blocking: {
          Id: 0,
          IdConfig: 0,
          IdCentro: action.centerId || null,
          NameBlocking: null,
          startDate: null,
          isNewConfig: true,
          endDate: null,
          workDays: [],
          startWorkDay: null,
          endWorkDay: null,
          satWorkstart: null,
          satWorkEnd: null,
          sunWorkStart: null,
          sunWorkEnd: null,
          satWorking: false,
          sunWorking: false,
          moduleTime: null,
          priorityData: [],
          data: [],
          completeData: [],
          dataPage: 0,
          dataPageLength: 0,
          BlockAll: false,
          ExamPools: [], // baterias
          Exams: [],
          Ciel: [],
          blockingData: null,
          comment: null,
          pagerStartDate: null,
          blockingReason: null
        },
      });
    }
    case "SET_QUOTES_LIST": {
      return Object.assign({}, state, {
        listQuotes: action.listQuotes,
      });
    }
    case "SET_VALIDATION_BLOCKING": {
      return Object.assign({}, state, {
        validationBlocking: action.validationBlocking,
      });
    }
    case "SET_DOWNLOAD_EXCEL_BLOCKING": {
      return Object.assign({}, state, {
        isDownloadExcel: action.isDownloadExcel,
      });
    }
    case "SET_OPEN_CONFLICT_OPEN": {
      return Object.assign({}, state, {
        isModalNameAndConflictOpen: action.isModalNameAndConflictOpen,
      });
    }
    case "SET_DATA_PAGE_MATRIZ": {
      let newBlocking = {...state.blocking};
      newBlocking.dataPage = action.page
      return Object.assign({}, state,{
        blocking: newBlocking
      })
    }
    case "RESET_STATES_BLOCKING": {
      return Object.assign({}, state, {
        isModalWizardLoading: false,
        centrosList: [],
        isOpenModalEditWeek: false,
        isOpenModalConflictWeek: false,
        isOpenModalDeleteBlocking: false,
        dataBlockingToDelete: null,
        appointment: {},
        appointmentEditWeek: {},
        feriadosAdministrativos: [],
        isDownloadExcel: false,
        isModalNameAndConflictOpen: false,
        centerId: null,
        centerConfig: {
          minWorkDay: null,
          maxWorkDay: null,
          minSatWork: null,
          maxSatWork: null,
          minSunWork: null,
          maxSunWork: null,
          listDaysWorking: [],
          listExamPools: [],
          listExams: [],
          listCiel: [],
        },
        validationBlocking: {
          quotes: 0,
          openValidation: false,
          message: null,
        },
        configList: [],
        steps: {
          stepOne: true,
          stepTwo: false,
          stepThree: false,
          stepSuccess: false,
        },
        isBackStep: false,
        isPopupWizardOpen: false,
        configSchedulerWizard: {
          startDayHour: 9,
          endDayHour: 17,
          cellDuration: 30,
        },
        listaAppointments: null,
        weekAppointments: null,
        blocking: {
          Id: 0,
          IdConfig: null,
          IdCentro: null,
          isNewConfig: true,
          NameBlocking: null,
          startDate: null,
          endDate: null,
          workDays: [],
          startWorkDay: null,
          endWorkDay: null,
          weekWorking: true,
          satWorkstart: null,
          satWorkEnd: null,
          sunWorkStart: null,
          sunWorkEnd: null,
          satWorking: false,
          sunWorking: false,
          moduleTime: null,
          priorityData: [],
          data: [],
          completeData: [],
          dataPage: 0,
          dataPageLength: 0,
          ExamPools: [],
          Exams: [],
          Ciel: [],
          BlockAll: false,
          blockingData: null,
          comment: null,
          pagerStartDate: null,
          blockingReason: null
        },
        modulesConfig: [],
        listQuotes: [],
        blockReasonList: []
      })
    }

    default:
      return state;
  }
};

export default Reducer;
